import {observer_mgl} from "mobx-graphlink";
import React, {useEffect, useRef, useState} from "react";
import {Button, Column, Row, Text} from "react-vcomponents";
import {RunInAction_Set} from "web-vcore";
import {DMap} from "../../../Server/DB/maps/@Map.js";
import {store} from "../../../Store/index.js";
import {GetSelectedObjects} from "../../../Store/main/maps/$mapState.js";
import {MapState} from "../../../Store/main/maps/@MapState.js";
import {colors} from "../../../Utils/UI/GlobalStyles.js";
import {MDIcon} from "../../../Utils/UI/MDIcon.js";
import {SplitView} from "../../../Utils/ReactComponents/SplitView.js";
import {OutlinerUI} from "../MapUI/OutlinerUI.js";
import {PropertiesUI} from "../MapUI/PropertiesUI.js";
import {SettingsUI} from "../MapUI/SettingsUI.js";
import {StatsUI} from "../MapUI/StatsUI.js";

export const MapSidebar = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	const uiState = store.main.maps;
	const [showToggle, setShowToggle] = useState(false);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(()=>{
		const el = containerRef.current;
		if (!el) return;
		const check = ()=>{
			const parent = el.parentElement;
			if (!parent) return;
			setShowToggle(!uiState.rightPanelShown || el.offsetWidth / parent.offsetWidth > .3);
		};
		const ro = new ResizeObserver(check);
		ro.observe(el);
		if (el.parentElement) ro.observe(el.parentElement); // also check when parent (basically equivalent to overall page) resizes
		return ()=>ro.disconnect();
	}, []); // eslint-disable-line

	return (
		<div ref={containerRef} style={{
			position: "relative",
			display: "flex", flexDirection: "column",
			...(uiState.rightPanelShown
				? {flex: 20, maxWidth: `calc(100% - 40px)`, minWidth: `min(400px, 100% - 40px)`, background: colors.mapUI_panels, border: "solid rgba(0,0,0,1)", borderWidth: "0 0 0 3px"}
				: {flex: "0 0 auto", width: 0, minWidth: 0, overflow: "visible"}),
		}}>
			{(showToggle || !uiState.rightPanelShown) &&
				<div onClick={()=>RunInAction_Set(()=>uiState.rightPanelShown = !uiState.rightPanelShown)} style={{
					position: "absolute", left: -28, width: 28, height: 48,
					//top: "50%", transform: "translateY(-50%)",
					bottom: 0,
					display: "flex", alignItems: "center", justifyContent: "center",
					background: colors.mapUI_panels, border: "solid rgba(0,0,0,.8)", borderWidth: "1px 0 1px 1px", borderRadius: "999px 0 0 999px",
					userSelect: "none", cursor: "pointer", zIndex: 10,
				}}>
					<MDIcon icon={!uiState.rightPanelShown ? "chevron-left" : "chevron-right"} size={20}/>
				</div>
			}
			{uiState.rightPanelShown && <>
				<SplitView direction="column" dividerSize={5}
					dividerStyle={{background: "rgba(0,0,0,.35)", border: "solid rgba(0,0,0,1)", borderWidth: "1px 0 0 0"}}
					minFirstPercent={.1} maxFirstPercent={.9}
					firstPercent={mapState.sidebarTopPanelPercent}
					onFirstPercentChange={percent=>RunInAction_Set(()=>mapState.sidebarTopPanelPercent = percent)}
				>
					<RightTopPanel {...{map, mapState}} />
					<PropertiesUI {...{map, mapState}} />
				</SplitView>
			</>}
		</div>
	);
});

const RightTopPanel = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	return (
		<Column style={{flex: 1}}>
			<Row>
				<Button p="0 7px" text="Outliner" onClick={()=>RunInAction_Set(()=>mapState.topRightPanel = "outliner")}/>
				<Button ml={5} p="0 7px" text="Settings" onClick={()=>RunInAction_Set(()=>mapState.topRightPanel = "settings")}/>
				<Button ml={5} p="0 7px" text="Stats" onClick={()=>RunInAction_Set(()=>mapState.topRightPanel = "stats")}/>
				<Row ml="auto">
					{mapState.selectedObjects.length > 0 && (()=>{
						const selectedObjects = GetSelectedObjects(map.id);
						const selectedObjectsMissing = mapState.selectedObjects.length - selectedObjects.length;
						const text = [
							`(`,
							`${mapState.selectedObjects.length} selected`,
							selectedObjectsMissing ? `, ${selectedObjectsMissing} missing` : ``,
							`)`,
						].join("");
						return <Text style={{fontSize: 12, color: "gray"}}>{text}</Text>;
					})()}
				</Row>
			</Row>
			{mapState.topRightPanel == "outliner" && <OutlinerUI {...{map, mapState}}/>}
			{mapState.topRightPanel == "settings" && <SettingsUI {...{map, mapState}}/>}
			{mapState.topRightPanel == "stats" && <StatsUI {...{map, mapState}}/>}
		</Column>
	);
});